export const compositionIds: { [key: string]: string } = {
    mereLaalanSimrit: "ae62298b-678a-4223-91ec-f0d47553d174",
    hePraanMaithili: "396b1e40-9c9c-4453-a84a-27ed0b300168",
    aiseLaalanPayo: "7b7c44ba-6bf3-4e08-835f-3ed2db837e0f",
    mayeeSantSang: "d1fb9808-bd57-4331-98f8-90550facd5bb",
    prabhMoheKabGal: "52b47370-387f-469f-b102-32d580b35dc3",
    mainBinGurDekhe: "603341c2-80aa-4b95-8e8e-b70c78fa9d48",
    jagatJalanda: "603341c2-80aa-4b95-8e8e-b70c78fa9d47",
};
